module.exports = __webpack_public_path__ + "static/img/A60.af657f9f.jpg";